<template>
  <div class="w-full h-full flex flex-col">
    <div class="flex justify-between items-center">
      <div class="title text-lg mb-10px cursor-pointer">
        <el-page-header v-if="pageType === 'read'" @back="$emit('cancel')" content="详情"></el-page-header>
        <span v-else class="border-l-3 border-color-primary pl-10px text-18px">{{ pageType === 'create' ? '新增' : '编辑'
          }}</span>
      </div>
    </div>
    <div v-loading="pageLoading" class="w-full overflow-hidden flex-1 pr-40px flex flex-col">
      <el-form ref="form" label-width="145px" :rules="rules" :model="formData" :disabled="canChange"
        class="flex-1 flex flex-col">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item ref="ExamName" label="考试名称" prop="ExamName">
              <el-input v-model="formData.ExamName" placeholder="请输入考试名称" show-word-limit clearable
                :disabled="canRead"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item label="考试编号" ref="ExamCode">
              <el-input v-model="formData.ExamCode" placeholder="请输入考试编号" show-word-limit clearable
                :disabled="canRead"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item ref="StrategyId" label="出卷策略" prop="StrategyId">
              <el-select v-model="formData.StrategyId" class="w-full" size="small" placeholder="请选择"
                :disabled="canRead">
                <el-option v-for="item in examCategoryList" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item ref="ExamStartTime" label="考试开始时间" prop="ExamStartTime">
              <el-date-picker class="w-full" style="width: 100%" v-model="formData.ExamStartTime" type="datetime"
                size="small" placeholder="选择开始时间" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm"
                :picker-options="startTimeOptions" clearable />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item ref="ExamEndTime" label="考试结束时间" prop="ExamEndTime">
              <el-date-picker class="w-full" style="width: 100%" v-model="formData.ExamEndTime" type="datetime"
                size="small" placeholder="选择结束时间" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm"
                :picker-options="endTimeOptions" clearable />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item label="单次考试时长(分钟)" prop="ExamDuration" ref="ExamDuration">
              <el-input-number class="w-full" :controls="false" :max="9999" :min="1" :precision="0" maxlength="10"
                show-word-limit :placeholder="'请输入'" v-model.number="formData.ExamDuration" clearable
                :disabled="canRead"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
            <el-form-item label="考生人数" prop="ExamineeCount" ref="ExamineeCount" style="order: -1">
              <el-input v-model="formData.ExamineeCount" placeholder="请输入" maxlength="20" show-word-limit disabled
                clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="考生" prop="ExamineeId">
          <el-button @click="openTreeSelect(formData, canChange)" type="primary" :disabled="false">{{
            canChange ? '查看' : '选择人员' }}</el-button>
          <el-button class="!ml-30px" v-if="!canChange" @click="openTreeSelect(formData, canChange, true)"
            type="primary" :disabled="false">选择班组</el-button>
        </el-form-item>
        <el-row class="pl-80px flex-1 overflow-hidden">
          <el-col :span="24" class="h-full">
            <el-table :data="examineeList" border class="w-full" stripe row-key="id" ref="table"
              :infinite-scroll-disabled="disabled" infinite-scroll-distance="50" :height="tableHeight">
              <el-table-column label="序号" type="index" width="100" show-overflow-tooltip></el-table-column>
              <el-table-column label="姓名" prop="name" width="200" show-overflow-tooltip></el-table-column>
              <el-table-column label="单位" prop="unitName" show-overflow-tooltip></el-table-column>
              <el-table-column label="班组" prop="teamName" show-overflow-tooltip></el-table-column>
              <template slot="append">
                <div v-if="noMore" class="flex items-center justify-center py-3 text-gray-400 text-sm border-t">
                  <i class="el-icon-info mr-1"></i>
                  没有更多考生数据了
                </div>
              </template>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="w-full flex justify-center items-center mt-2.5 mb-2.5" v-if="pageType !== 'read'">
      <el-button type="primary" size="small" @click="submitForm('submit')" :loading="saveLoading"
        :disabled="pageLoading">保存</el-button>
      <el-button @click="$emit('cancel')" size="small">取消</el-button>
    </div>
    <wiz-tree-select :visible.sync="userDialogVisible" :treeData="orgUserTree" treeCheckField="isActive" @save="addUser"
      :defaultSelectKeys="defaultSelectKeys" :treeExpandedKeys="treeExpandedKeys" :disabledKeys="disabledKeys"
      :title="userDialogTitle" treeNodeKey="key" repeatKey="id" :filterRepeat="true" :disabled="treeSelectDisabled" />
    <wiz-tree-select :visible.sync="teamUserDialogVisible" :treeData="teamUserTree" treeCheckField="isActive"
      @save="addUser" :defaultSelectKeys="defaultSelectKeys" :treeExpandedKeys="treeExpandedKeys"
      :disabledKeys="disabledKeys" :title="userDialogTitle" treeNodeKey="key" repeatKey="id" :filterRepeat="true"
      :disabled="treeSelectDisabled" />
  </div>
</template>

<script>
import { ExamPlanApi } from '@wiz-api/exam-management'
import { TeamApi } from '@wiz-api/team-management'
import { EafOrganizationUnitUserApi } from '@wiz-api/account'
import DiyService from '@/modules/educational-training-management-sm/services/DiyService'
import dayjs from 'dayjs'
import { sumBy, cloneDeep, map, uniq, filter, find, chunk, isEmpty } from 'lodash'
import MultipleExamSelect from '../MultipleExamSelect'
import { typeList } from '../EnumField'

const teamApi = new TeamApi()
const examPlanApi = new ExamPlanApi()
const eafOrganizationUnitUserApi = new EafOrganizationUnitUserApi()

export default {
  name: 'exam-plan-form',
  components: {
    MultipleExamSelect,
  },
  props: {
    /**
     * @description: 上传传递的参数
     * @return {*}
     */
    pageType: {
      type: String,
      default: 'create',
    },
    rowId: {
      type: String,
      default: null,
    },
    operateData: {
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      teamUserDialogVisible: false,
      teamUserTree: [],
      userDialogTitle: '',
      userDialogVisible: false,
      treeSelectDisabled: false,
      orgUserTree: [],
      treeExpandedKeys: [],
      disabledKeys: [],
      currentSelect: {
        row: null,
        field: '',
        isTeam: false,
      },
      defaultSelectKeys: [],
      tableLoading: false,
      pageLoading: false,
      typeList,
      saveLoading: false,
      formData: {
        ExamName: '',
        ExamCode: '',
        StrategyId: '',
        ExamStartTime: '',
        ExamEndTime: '',
        ExamDuration: '',
        ExamineeId: '',
        IsPublished: 0,
        ExamineeCount: '',
      },
      examineeList: [],
      addExamineeList: [],
      tableParams: {
        pageIndex: 1,
        pageSize: 15
      },
      loading: false,
      noMore: false,
      rules: {
        ExamName: [
          { required: true, message: '请输入考试名称', trigger: 'blur' },
          { min: 2, max: 50, message: '考试名称长度应在2-50个字符之间', trigger: 'blur' }
        ],
        // ExamCode: [
        //   { required: true, message: '请输入考试编号', trigger: 'blur' },
        //   { pattern: /^[A-Za-z0-9-_]+$/, message: '考试编号只能包含字母、数字、下划线和连字符', trigger: 'blur' }
        // ],
        StrategyId: [
          { required: true, message: '请选择出卷策略', trigger: 'change' }
        ],
        ExamStartTime: [
          { required: true, message: '请选择考试开始时间', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (value && this.formData.ExamEndTime && new Date(value) >= new Date(this.formData.ExamEndTime)) {
                callback(new Error('开始时间必须早于结束时间'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        ExamEndTime: [
          { required: true, message: '请选择考试结束时间', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (value && this.formData.ExamStartTime && new Date(value) <= new Date(this.formData.ExamStartTime)) {
                callback(new Error('结束时间必须晚于开始时间'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ],
        ExamDuration: [
          { required: true, message: '请输入考试时长', trigger: 'blur' },
          { type: 'number', message: '考试时长必须为数字', trigger: 'blur' },
          { type: 'number', min: 1, max: 1440, message: '考试时长必须在1-1440分钟之间', trigger: 'blur' }
        ],
        ExamineeId: [
          { required: true, message: '请选择考生', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (value && value.split(',').length > 500) {
                callback(new Error('考生人数不能超过500人'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      },
      startTimeOptions: {
        disabledDate: (time) => {
          const endTime = this.formData?.ExamEndTime || null
          return time.getTime() < Date.now() - 8.64e7 || (endTime && time.getTime() > new Date(endTime).getTime())
        }
      },
      endTimeOptions: {
        disabledDate: (time) => {
          const startTime = this.formData?.ExamStartTime || null
          if (startTime) {
            return time.getTime() < new Date(startTime).getTime()
          }
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      examCategoryList: [],
    }
  },
  computed: {
    canChange() {
      return ['read'].includes(this.pageType)
    },
    canRead() {
      return ['read', 'change'].includes(this.pageType)
    },
    tableHeight() {
      return this.pageType === 'read' ? 'calc(100vh - 480px)' : 'calc(100vh - 500px)'
    },
    disabled() {
      return this.loading || this.noMore
    }
  },
  methods: {
    async getOrgUserTree() {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserTree({})
      if (!err && res.length) {
        this.orgUserTree = this.processedTreeData(res)
        this.treeExpandedKeys = [res[0].organizationUnitId]
      }
    },
    processedTreeData(treeData) {
      const hanldeData = []
      treeData.forEach((item) => {
        const cloneTreeItem = cloneDeep(item)
        cloneTreeItem.label = item.organizationUnitName
        cloneTreeItem.id = item.organizationUnitId
        cloneTreeItem.key = item.organizationUnitId
        let hanldeChildren = []
        if (item.childen && item.childen.length) {
          hanldeChildren = this.processedTreeData(item.childen)
        }
        const activeUserList = filter(item.userList, (user) => {
          return user.isActive
        })
        const userList = map(activeUserList, (user) => {
          return {
            ...user,
            key: `${item.organizationUnitId}-${user.id}`,
            label: user.name,
            unitName: item.organizationUnitName
          }
        })
        delete cloneTreeItem.userList
        delete cloneTreeItem.childen
        cloneTreeItem.children = [...hanldeChildren, ...userList]
        hanldeData.push(cloneTreeItem)
      })
      return hanldeData
    },

    getAllUserIdsFromTree(nodes) {
      if (!nodes) return []
      const ids = []
      if (Array.isArray(nodes)) {
        nodes.forEach((node) => {
          ids.push(...this.getAllUserIdsFromTree(node))
        })
      } else if (nodes.children) {
        nodes.children.forEach((child) => {
          if (child.userList) {
            ids.push(...child.userList.map((user) => { return user.id }))
          } else if (child.id && !child.children) {
            ids.push(child.id)
          } else {
            ids.push(...this.getAllUserIdsFromTree(child))
          }
        })
      }
      return ids
    },

    addUser(data) {
      if (this.currentSelect.isTeam) {
        const teamUserIds = this.getAllUserIdsFromTree(this.teamUserTree) || []
        const dataIds = data.map((item) => { return item.id })

        this.examineeList.push(...data)
        this.examineeList = Array.from(new Map(this.examineeList.map((item) => { return [item.id, item] })).values())
        this.examineeList = this.examineeList.filter((item) => {
          return !(teamUserIds.includes(item.id) && !dataIds.includes(item.id))
        })

        this.defaultSelectKeys = dataIds
      } else {
        const orgUserIds = this.getAllUserIdsFromTree(this.orgUserTree) || []
        const dataIds = data.map((item) => { return item.id })

        this.examineeList.push(...data)
        this.examineeList = Array.from(new Map(this.examineeList.map((item) => { return [item.id, item] })).values())
        this.examineeList = this.examineeList.filter((item) => {
          return !(orgUserIds.includes(item.id) && !dataIds.includes(item.id))
        })
      }

      this.formData.ExamineeCount = this.examineeList.length
      this.formData.ExamineeId = this.examineeList.map((item) => { return item.id }).join(',')
      this.noMore = true
      this.tableParams.pageIndex = 1
    },
    async openTreeSelect(row, disabled, isTeam = null) {
      this.disabledKeys = []
      this.treeSelectDisabled = disabled
      this.userDialogTitle = '选择考生'
      this.currentSelect.row = row
      this.currentSelect.field = 'ExamineeId'
      this.currentSelect.isTeam = isTeam
      this.defaultSelectKeys = row.ExamineeId ? row.ExamineeId.split(',') : []
      if (this.pageType === 'change') {
        const [err, res] = await examPlanApi.getHaveParticipateUsers(row.id)
        if (!err) {
          this.disabledKeys.push(...res)
        }
      }
      if (isTeam) {
        this.treeExpandedKeys = [this.teamUserTree[0].id]
        this.teamUserDialogVisible = true
      } else {
        this.treeExpandedKeys = [this.orgUserTree[0].organizationUnitId]
        this.userDialogVisible = true
      }
    },

    // 获取详情
    async getDetail() {
      this.pageLoading = true
      const [err, res] = await DiyService.getFormData({ FormEngineKey: 'diy_ExaminationPlan', Id: this.operateData.Id })
      if (!err && res.Code === 1) {
        this.formData = res.Data
        if (this.formData.ExamineeId) {
          const examinees = this.formData.ExamineeId.split(',').slice((this.tableParams.pageIndex - 1) * this.tableParams.pageSize, this.tableParams.pageIndex * this.tableParams.pageSize)
          const [userErr, userList] = await this.getUserList(examinees)
          if (!userErr && userList) {
            this.examineeList.push(...userList)
            this.tableParams.pageIndex = +1
            this.noMore = this.formData.ExamineeCount <= this.examineeList.length
          }
        }
      } else {
        this.$message.error(res.Msg)
      }
      this.pageLoading = false
    },
    async getUserList(ids) {
      if (!ids || ids.length === 0) return [null, []]

      const filterIds = ids.filter((item) => {
        const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
        return uuidPattern.test(item)
      })

      if (filterIds.length === 0) return [null, []]

      try {
        const [userErr, userRes] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
          userIdList: filterIds,
          skipCount: 0,
          maxResultCount: filterIds.length,
        })

        if (!userErr && userRes?.items) {
          const userList = userRes.items.map((user) => {
            // 查找用户所在的班组
            let teamName = ''
            if (!teamErr && teamRes?.items) {
              const team = teamRes.items.find((t) => { return t.members?.some((m) => { return m.accountId === user.id }) })
              if (team) {
                teamName = team.name
              }
            }

            return {
              id: user.id,
              name: user.name,
              unitName: user.orgUnits?.[0]?.organizationUnitName || '',
              teamName
            }
          })
          return [null, userList]
        }
        return [userErr, null]
      } catch (error) {
        console.error('获取用户信息失败:', error)
        return [error, null]
      }
    },
    /**
     * 表单提交
     */
    async submitForm() {
      this.$refs.form.validate(async (valid, object) => {
        if (valid) {
          if (this.pageType === 'change') {
            const [err, res] = await DiyService.getTableData({
              FormEngineKey: 'diy_ExaminationPlan',
              _FormData: this.formData,
            })
            if (!err && res.Code === 1) {
              this.$message({
                showClose: true,
                message: '变更成功',
                type: 'success',
              })
              this.$emit('refreshList')
            } else {
              this.$message({
                showClose: true,
                message: res.Msg,
                type: 'error',
              })
            }
          } else if (this.formData.Id) {
            // 编辑
            const [err, res] = await DiyService.updateFormData({
              FormEngineKey: 'diy_ExaminationPlan',
              Id: this.formData.Id,
              _FormData: this.formData,
            })
            if (!err && res.Code === 1) {
              this.$message({
                showClose: true,
                message: '编辑成功',
                type: 'success',
              })
              this.$emit('refreshList')
            } else {
              this.$message({
                showClose: true,
                message: res.Msg,
                type: 'error',
              })
            }
          } else {
            // 新增
            const [err, res] = await DiyService.addFormData({
              FormEngineKey: 'diy_ExaminationPlan',
              _FormData: this.formData,
            })
            if (!err && res.Code === 1) {
              this.$message({
                showClose: true,
                message: '新增成功',
                type: 'success',
              })
              this.$emit('refreshList')
            } else {
              this.$message({
                showClose: true,
                message: res.Msg,
                type: 'error',
              })
            }
          }
        } else {
          // 验证不通过定位到第一个错误的地方
          const keyList = Object.keys(object)
          if (keyList && keyList.length) {
            const el = this.$refs[keyList[0]].$el
            el.scrollIntoView(true)
          }
        }
      })
    },
    // 获取人员信息
    async getTeamUserInfo(ids) {
      const [err, res] = await eafOrganizationUnitUserApi.getOrganizationUnitUserList({
        userIdList: ids,
      })
      if (!err) {
        return res.items
      }
      return []
    },
    // 获取策略信息
    async getStrategyList() {
      const [err, res] = await DiyService.getTableData({
        TableName: 'diy_QuestionStrategy',
        _PageSize: 999,
        _PageIndex: 1,
        _Where: [
          { Name: 'ShortAnswerCount', Value: 0, Type: '=' },
          { AndOr: 'and', Name: 'IsDeleted', Value: 0, Type: '=' },
          { AndOr: 'and', Name: 'PassingMark', Value: null, Type: '!=' },
        ],
      })
      if (!err && res.Code === 1) {
        this.examCategoryList = _.map(res.Data, (item) => {
          return { name: item.Name, id: item.Id }
        })
      } else {
        this.$message.error(res.Msg)
      }
    },
    // 获取班组人员列表
    async getTeamUserTree() {
      const [err, res] = await teamApi.pagedListQuery({
        skipCount: 0,
        maxResultCount: 999,
        isEnabledPermissions: false,
      })
      if (!err) {
        const teamList = res.items
        for (let i = 0; i < teamList.length; i += 1) {
          const item = teamList[i]
          const users = await this.getTeamUserInfo(_.map(item.members, 'accountId'))
          this.$set(teamList[i], 'userList', users)
        }
        this.teamUserTree = this.processedTeamTreeData(teamList)
        this.treeExpandedKeys = [teamList[0].id]
      }
    },
    processedTeamTreeData(treeData) {
      const hanldeData = []
      treeData.forEach((item) => {
        const cloneTreeItem = cloneDeep(item)
        cloneTreeItem.label = item.name
        cloneTreeItem.id = item.id
        cloneTreeItem.key = item.id
        const activeUserList = filter(item.userList, (user) => {
          return user.isActive
        })
        const userList = map(activeUserList, (user) => {
          return {
            ...user,
            key: `${item.id}-${user.id}`,
            label: user.name,
            unitName: user.orgUnits[0].organizationUnitName,
            teamName: item.name,
          }
        })
        delete cloneTreeItem.userList
        delete cloneTreeItem.childen
        cloneTreeItem.children = [...userList]
        hanldeData.push(cloneTreeItem)
      })
      return hanldeData
    },
    initTableScroll() {
      // 获取表格的滚动容器并添加滚动监听
      this.$nextTick(() => {
        const tableWrapper = this.$refs.table.$el.querySelector('.el-table__body-wrapper')
        if (tableWrapper) {
          tableWrapper.addEventListener('scroll', this.handleTableScroll)
        }
      })
    },
    handleTableScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      // 当滚动到底部时（考虑一个小的缓冲区）
      if (scrollHeight - scrollTop - clientHeight < 50 && !this.loading && !this.noMore) {
        this.loadMore()
      }
    },
    async loadMore() {
      if (this.loading) return
      this.loading = true

      this.tableParams.pageIndex += 1
      const examinees = this.formData.ExamineeId.split(',').slice(
        (this.tableParams.pageIndex - 1) * this.tableParams.pageSize,
        this.tableParams.pageIndex * this.tableParams.pageSize
      )

      if (examinees.length === 0) {
        this.noMore = true
        this.loading = false
        return
      }

      const [userErr, userList] = await this.getUserList(examinees)
      if (!userErr && userList) {
        this.examineeList.push(...userList)
        this.noMore = this.formData.ExamineeCount <= this.examineeList.length
      }
      this.loading = false
    },
  },
  created() {
    this.getOrgUserTree()
    this.getTeamUserTree()
    this.getStrategyList()
  },
  mounted() {
    this.initTableScroll()
    if (this.pageType !== 'create') {
      this.getDetail()
    }
  },
  beforeDestroy() {
    // 移除滚动监听
    const tableWrapper = this.$refs.table.$el.querySelector('.el-table__body-wrapper')
    if (tableWrapper) {
      tableWrapper.removeEventListener('scroll', this.handleTableScroll)
    }
  }
}
</script>

<style scoped lang="scss">
.custom-height {
  height: calc(100% - 95px);
}

.detail-height {
  height: calc(100% - 50px);
}
</style>
